// Librerie
import React from "react"
import { useTranslation } from "react-i18next";


interface WidgetPartnersProps {
    partners: { url: string, imgSrc: string, imgAlt: string }[];
}

export const WidgetPartners: React.FC<WidgetPartnersProps> = ({ partners }) => {

    const { t } = useTranslation();
    const countPartners = partners.length;

    return (
        <div className="widget-partners">
            <h3>{t('widgets.partners.title')}</h3>
            <ul className="list-unstyled mb-0 pl-3">
                {partners.map(({ url, imgSrc, imgAlt }, index) => (
                    <li key={index} className={countPartners-1 == index ? "" : "mb-3"}>
                        <a href={url} target="_blank" title={imgAlt} className="d-block">
                            <img src={imgSrc} alt={imgAlt} />
                        </a>
                    </li>
                ))}
                <li className="pt-4">
                    <strong>STUDIO TECNICO BONACCORSO</strong>
                    <ul className="pl-3">
                        <li>
                            <a href="tel:+393355379797" title="STUDIO TECNICO BONACCORSO - VITO" className="d-block">
                                Geom. Vito Bonaccorso cell <strong style={{ whiteSpace: 'nowrap' }}>335 5379797</strong>
                            </a>
                        </li>
                        <li>
                            <a href="tel:+393926764392" title="STUDIO TECNICO BONACCORSO - ANDREA" className="d-block">
                                Geom. Andrea Bonaccorso cell <strong style={{ whiteSpace: 'nowrap' }}>392 6764392</strong>
                            </a>
                        </li>
                    </ul>
                    Via delle Commedie n° 19 - 57123 Livorno
                </li>
            </ul>
        </div>
    );
};

export default WidgetPartners;